module.exports = __webpack_public_path__ + "static/global-partners2-bc2c56d541180dee48f3f731d6f3fba0.jpg";